var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "237px",
    height: "169px",
    viewBox: "0 0 237 169",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "welcome_illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-34",
    transform: "translate(-66.000000, -165.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome_illustration",
    transform: "translate(66.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 0,
    y: 168,
    width: 237,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,139 L7,139 L7,33 L90,33 L90,139 Z M7.46629213,138.535088 L89.5337079,138.535088 L89.5337079,33.4649123 L7.46629213,33.4649123 L7.46629213,138.535088 Z",
    id: "Shape",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 13,
    y: 40,
    width: 72,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 13,
    y: 83,
    width: 72,
    height: 49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 47,
    y: 39,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 80,
    y: 39,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(49.000000, 83.000000) rotate(90.000000) translate(-49.000000, -83.000000) ",
    points: "47 47 51 47 51 119 47 119"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "22.6012805 64 16 68.3782201 16 72 26 64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "33.8793583 64 17 77.0234682 17 80 39 64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 13,
    y: 39,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "74.5198889 43.686747 60 61.5421687 64.4861111 62 77 43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(49.000000, 41.000000) rotate(90.000000) translate(-49.000000, -41.000000) ",
    points: "47 5 51 5 51 77 47 77"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(49.000000, 62.000000) rotate(90.000000) translate(-49.000000, -62.000000) ",
    points: "47 26 51 26 51 98 47 98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7030972,123.533634 C65.4836493,124.733645 65.1440149,125.909138 64.6892019,127.042781 C64.0120541,128.727649 63.0830589,130.302716 61.933186,131.715475 C61.8559146,131.81263 61.7763015,131.907471 61.6966885,132 C61.6053677,131.905158 61.5187299,131.810316 61.4344197,131.715475 L33.0758036,131.715475 C31.5787164,129.875066 30.4560121,127.766022 29.7695213,125.504493 C29.2134978,123.667883 28.9558479,121.755777 29.0061728,119.83943 C29.1720601,112.972875 33.2211797,106.778029 39.4878984,103.803185 C45.7546172,100.82834 53.1805927,101.575898 58.7110989,105.738345 C64.2416051,109.900792 66.9426334,116.775161 65.7030972,123.533634 L65.7030972,123.533634 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 49.5,
    cy: 115.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 51,
    cy: 119,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0093069,100.581833 C32.7351271,93.9377623 38.5525964,88.3102024 46.0030001,88.0123108 C53.4534037,87.7144192 59.715425,92.8590044 59.9896094,99.503075 C60.2637938,106.147146 55.0848149,107.656727 47.6344089,107.954618 C40.184003,108.25251 33.2834867,107.225897 33.0093069,100.581833 Z",
    id: "Path",
    fill: "#FEC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6757912,137.677121 C70.5188526,138.834208 66.5914764,136.783009 62.9031371,133.096588 C62.6091217,132.802535 62.3246558,132.506091 62.0545561,132.209647 C61.9613317,132.11163 61.872888,132.013612 61.7868204,131.915594 C58.8179822,128.604509 57.2881604,125.357973 58.3231758,124.32281 C59.2721523,123.373712 62.0903973,124.583394 65.1094333,127.086431 C65.7667847,127.633895 66.4360881,128.243517 67.0958299,128.903344 C68.040567,129.843646 68.916879,130.850295 69.7180647,131.915594 C71.6638393,134.531 72.5195914,136.835599 71.6757912,137.677121 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    transform: "translate(28.757600, 119.919666) rotate(-73.093720) translate(-28.757600, -119.919666) ",
    cx: 28.7576002,
    cy: 119.919666,
    rx: 2.88503347,
    ry: 9.17905702
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9425563,129.42391 C50.7483005,130.483143 50.1110755,131.416179 49.1831939,132 L44.823712,132 C43.4701681,131.143818 42.7765494,129.579832 43.0643497,128.032952 C43.4580376,125.914015 45.3041447,125.786185 47.4794372,126.169674 C49.6547297,126.553163 51.3362442,127.302811 50.9425563,129.42391 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,159.562481 L56.09375,162.910654 L57.1875,167.151673 C57.1875,167.151673 60.03125,168.714153 60.25,167.598096 C60.46875,166.482038 59.15625,166.258826 59.15625,166.258826 L58.71875,164.026711 L62,158 L55,159.562481 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,158 L76.089711,167.412305 C76.089711,167.412305 77.7150417,168.330579 78.8759923,167.871442 C80.0369428,167.412305 78.1794219,166.264463 78.1794219,166.264463 C78.1794219,166.264463 78.8759923,160.525253 82.3588439,159.836547 C85.8416955,159.147842 74,158 74,158 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7154418,147.162902 C87.7154418,147.162902 83.0283135,148.806554 78.8098981,147.867324 C78.8098981,147.867324 70.6074236,146.693287 69.9043543,146.458479 C69.2012851,146.223672 61.233167,145.754057 57.0147515,146.458479 C57.0147515,146.458479 45.2969308,137.300986 51.8589104,133.309259 C51.8589104,133.309259 54.6711873,134.718104 55.3742566,133.778874 C55.6379076,133.426663 55.5060821,132.975391 55.2383111,132.548886 C54.6243192,131.608043 53.5869538,131.030851 52.4652771,131.005966 C50.0162526,130.914103 45.6278631,131.795788 47.6197778,139.818092 C48.1876814,142.030837 49.2337049,144.091611 50.6839246,145.854777 C51.7508861,147.172987 52.8549251,148.997335 52.3276232,150.450207 C51.3901975,153.033089 51.1558411,157.024817 51.1558411,157.024817 L47.8748513,161.955775 C47.8748513,161.955775 46,168.06077 46,168.295577 C46,168.530385 48.5494884,169.028487 49.0466334,168.530385 C49.5153462,168.06077 48.3435641,167.12154 48.3435641,167.12154 C48.3435641,167.12154 49.2809898,165.24308 50.9214847,164.773465 C52.5619796,164.30385 57.0147515,162.660197 57.7178207,161.955775 C58.42089,161.251352 73.4197005,157.024817 77.638116,161.016545 C80.0053509,163.282391 82.5099144,165.399684 85.1375213,167.356347 C85.1375213,167.356347 86.3093033,169 87.7154418,169 C89.1215803,169 89.3559367,166.886732 87.7154418,166.651925 C86.0749469,166.417117 83.7313828,160.781737 83.7313828,160.781737 C83.7313828,160.781737 83.0283135,156.555202 86.5436598,155.85078 C88.4815319,155.46246 89.6359926,155.430913 90.2818953,155.480798 C90.8031065,155.524204 91.3195588,155.353626 91.7128287,155.008178 C92.1310358,154.605267 92.5056356,154.15926 92.8304042,153.677568 C93.0043353,153.429384 93.047428,153.112133 92.9460192,152.826405 C92.6338613,151.972772 92.3741078,151.100809 92.1682137,150.215399 C91.9338573,149.041362 90.059006,148.102132 90.059006,148.102132 C90.059006,148.102132 89.5902931,144.814827 88.8872239,145.754057 C88.5269551,146.24818 88.1355649,146.718753 87.7154418,147.162902 L87.7154418,147.162902 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,117 L134,117 L134,11 L217,11 L217,117 Z M134.466292,116.535088 L216.533708,116.535088 L216.533708,11.4649123 L134.466292,11.4649123 L134.466292,116.535088 Z",
    id: "Shape",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 140,
    y: 18,
    width: 72,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 140,
    y: 61,
    width: 72,
    height: 49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 174,
    y: 17,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 208,
    y: 17,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(176.000000, 61.000000) rotate(90.000000) translate(-176.000000, -61.000000) ",
    points: "174 25 178 25 178 97 174 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "149.601281 42 143 46.3782201 143 50 153 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "160.879358 42 144 55.0234682 144 58 166 42"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    x: 140,
    y: 17,
    width: 4,
    height: 46
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "201.519889 20.686747 187 38.5421687 191.486111 39 204 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(176.000000, 19.000000) rotate(90.000000) translate(-176.000000, -19.000000) ",
    points: "174 -17 178 -17 178 55 174 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#2F2E41",
    transform: "translate(176.000000, 40.000000) rotate(90.000000) translate(-176.000000, -40.000000) ",
    points: "174 4 178 4 178 76 174 76"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(176.404790, 53.470607) rotate(-48.311800) translate(-176.404790, -53.470607) ",
    cx: 176.40479,
    cy: 53.470607,
    rx: 4.2774897,
    ry: 2.57864846
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6584",
    cx: 185,
    cy: 61,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.168902,56.005795 L141.937011,56.8650429 C141.105012,56.9349178 140.446807,57.616815 140.386477,58.4713894 L140.004433,63.8827955 C139.970441,64.3642239 140.133077,64.8384722 140.453371,65.1919055 C140.773665,65.5453388 141.222753,65.746108 141.69303,65.7461068 L146.30458,65.7461068 L146.30458,66 L148.159879,66 L148.159879,65.7461068 L149.149371,65.7461068 L149.149371,66 L151.004669,66 L151.004669,65.7461068 L151.993667,65.7461068 C152.895,65.7461056 153.638309,65.0212997 153.684475,64.0973892 L153.997775,57.8267211 C154.022777,57.3263634 153.836154,56.8392778 153.485786,56.4904328 C153.135419,56.1415878 152.655406,55.9649342 152.168902,56.005795 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.801862,73.7113349 L143.708979,67 L141,71.0268014 C141,71.0268014 148.848006,75.7659449 149.255935,76.1518202 C149.836433,76.7009288 156.092883,80.544694 158.543864,79.9345733 C160.994845,79.3244525 159.833853,74.3214557 158.801862,73.7113349 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "167.931936 105.277778 166 110 186 110 184.547299 105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.065887,70.5727102 C180.065887,70.5727102 180.798265,74.7627177 180.065887,75.2705968 C179.333508,75.7784759 184.94842,82 184.94842,82 L187.267621,79.8415113 L188,74.8896875 C188,74.8896875 185.802862,71.7154382 186.779367,68.9220936 C187.755872,66.128749 180.065887,70.5727102 180.065887,70.5727102 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 183,
    cy: 64,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.431649,78.6781371 C184.431649,78.6781371 181.253538,73.9364478 179.473794,73.5621042 C177.694051,73.1877607 176.041434,73.4373277 175.024439,73.5621042 C174.007444,73.6868808 170.575081,72.4390736 168.541101,73.3125511 C166.50712,74.1860286 168.541101,84.4180851 168.541101,84.4180851 C168.541101,84.4180851 166.25286,97.5201225 167.269857,100.889217 C168.286854,104.258311 167.524096,104.882219 167.015618,105.256562 C166.507139,105.630906 178.583945,109 178.583945,109 L190.02515,109 C190.02515,109 190.02515,105.381344 191.169269,104.507873 C192.313389,103.634402 192.186264,85.1667744 192.186264,85.1667744 L196,77.9294593 C196,77.9294593 195.364378,75.1842711 192.694764,75.0594899 C190.02515,74.9347087 187.642168,73.5590321 187.642168,73.5590321 L185.830032,78.6781463 L184.431649,78.6781371 Z",
    id: "Path",
    fill: "#5E9A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,73.6834432 L168.884296,73.0448637 C168.884296,73.0448637 166.776858,73.1725749 166.404957,73.0448637 C166.033057,72.9171525 161.322313,71.3845548 159.46281,72.2785684 C157.603308,73.172582 156.363635,72.023146 156.363635,72.023146 C156.363635,72.023146 162.438014,77.3872182 155,79.0475248 C155,79.0475248 155.123962,79.6861066 156.983472,80.0692543 C158.842981,80.4524019 159.214874,80.8355496 159.958678,81.4741291 C160.702481,82.1127085 162.190083,82.7512903 163.181818,83.0067221 C164.173552,83.2621539 167.396694,85.4333264 167.892562,84.9224629 C168.388429,84.4115993 169.256197,82.6235745 169.256197,82.6235745 L170,73.6834432 Z",
    id: "Path",
    fill: "#5E9A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82743,77 L196.307148,78.3790021 C196.307148,78.3790021 199.569933,87.6559194 199.047888,89.9124646 C198.525843,92.1690097 198.003797,91.7929212 198.786875,93.297287 C199.569953,94.8016527 200.353011,94.927014 199.830966,96.3060162 C199.30892,97.6850183 199.569953,101.069838 198.786875,102.448838 C198.003797,103.827838 194.218974,108.215583 190.956188,100.819111 C187.693402,93.422639 193.82743,77 193.82743,77 Z",
    id: "Path",
    fill: "#5E9A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,95.7920466 C198,95.7920466 196.237382,92.2537586 195.859679,92.0010241 C195.481976,91.7482895 193.719358,83.0289414 193.719358,83.0289414 C193.719358,83.0289414 196.489185,78.4797152 193.971151,76.4578367 C193.971151,76.4578367 198.629496,69.8867343 197.118681,70.0131109 C195.607865,70.1394875 192.586239,74.9414389 192.586239,74.9414389 C192.586239,74.9414389 191.893781,74.751888 192.145583,73.7409475 C192.397385,72.7300071 193.341646,69.1285401 192.586239,69.0021705 C191.830833,68.8758009 190.320017,74.3096025 190.320017,74.3096025 C190.320017,74.3096025 187.235438,79.9329504 188.179697,81.891643 C188.729037,82.9909391 189.36034,84.0470067 190.068215,85.0508293 L192.208534,100.720384 C192.208534,100.720384 196.363284,105.775074 198,95.7920466 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#6C63FF",
    cx: 151.5,
    cy: 58.5,
    rx: 1.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.624996,71 L140.874995,71 C140.874995,71 137,69.7256876 137,66.7947643 C137,63.8638411 138.124998,57.8745704 141.624993,58.0020016 C145.124989,58.1294328 141.874995,66.0301769 141.874995,66.0301769 L143.993762,66.9115869 L144,69.598254 L142.624996,71 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    cx: 181,
    cy: 58.5,
    rx: 7,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 191.5,
    cy: 62.5,
    rx: 1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(194.758119, 55.484846) rotate(-25.902070) translate(-194.758119, -55.484846) ",
    cx: 194.758119,
    cy: 55.4848456,
    rx: 2.577716,
    ry: 4.27903493
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 139,
    y: 128.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 162.767647,
    y: 129,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 148.767647,
    y: 129,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 113,
    y: 0.767313019,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 136.767647,
    y: 2,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 122.767647,
    y: 2,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 99,
    y: 59.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 122.767647,
    y: 60,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 108.767647,
    y: 60,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 28,
    y: 8.76731302,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 51.7676471,
    y: 10,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 37.7676471,
    y: 10,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 153,
    y: 145.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 161.767647,
    y: 142,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 175.767647,
    y: 142,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 102,
    y: 155.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 110.767647,
    y: 151,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 125.767647,
    y: 151,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 106,
    y: 122.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 115.767647,
    y: 119,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 129.767647,
    y: 119,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 92,
    y: 76.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 100.767647,
    y: 72,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 115.767647,
    y: 72,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 69,
    y: 24.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 78.7676471,
    y: 21,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 92.7676471,
    y: 21,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 7,
    y: 152.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 16.7676471,
    y: 149,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 30.7676471,
    y: 149,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 201,
    y: 135.767313,
    width: 33,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 209.767647,
    y: 132,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 223.767647,
    y: 132,
    width: 1,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 113,
    cy: 98,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 189,
    cy: 127,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 115,
    cy: 45,
    r: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIllustration);
export default __webpack_public_path__ + "static/media/welcome_illustration.76af64c4827b7dfc4933371a81b86f0b.svg";
export { ForwardRef as ReactComponent };